import React, { useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
  // Modal State Logic
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);

  return (
    <div className="font-sans">
      
      {/* ================= DONATE MODAL (Popup) ================= */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(5px)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header bg-primary text-white border-0 rounded-top-4 p-4">
                <h5 className="modal-title fw-bold">
                  <i className="bi bi-heart-fill me-2 text-warning"></i> Support Our Cause
                </h5>
                <button type="button" className="btn-close btn-close-white shadow-none" onClick={toggleModal}></button>
              </div>
              <div className="modal-body p-4 text-center">
                <p className="text-muted mb-4">Your contribution helps us provide education and healthcare to the underprivileged.</p>
                
                {/* QR Code Placeholder */}
                <div className="bg-light p-3 rounded-4 mb-4 d-inline-block shadow-sm border">
                  <img 
                    src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=SankalpSewaSansthan" 
                    alt="Donate QR Code" 
                    className="img-fluid rounded-3"
                    style={{ width: '180px' }}
                  />
                  <p className="mt-2 mb-0 small fw-bold text-primary">Scan to Pay via UPI</p>
                </div>

                {/* Bank Details Card */}
                <div className="card border-0 bg-light rounded-4 text-start p-3 shadow-sm">
                  <h6 className="fw-bold text-dark border-bottom pb-2 mb-3">Bank Account Details</h6>
                  <div className="small text-secondary">
                    <div className="d-flex justify-content-between mb-2">
                      <span>Account Name:</span>
                      <span className="text-dark fw-medium">SANKALP SEWA SANSTHAN</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span>Account Number:</span>
                      <span className="text-dark fw-medium">XXXXXXXXXXXXXX</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span>IFSC Code:</span>
                      <span className="text-dark fw-medium">SBIN00XXXXX</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>Bank Name:</span>
                      <span className="text-dark fw-medium">State Bank of India</span>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      )}

      {/* ================= NAVBAR ================= */}
      <nav
  className="navbar navbar-expand-lg navbar-dark sticky-top shadow-sm py-3 position-relative"
  style={{
    background:
      "linear-gradient(135deg, #0d6efd 0%, #084298 100%)",
    backdropFilter: "blur(10px)",
    zIndex: 999
  }}
>

  {/* LIGHT EFFECT */}
  <div
    className="position-absolute top-0 start-0"
    style={{
      width: "250px",
      height: "250px",
      background: "rgba(255,255,255,0.08)",
      borderRadius: "50%",
      filter: "blur(70px)"
    }}
  ></div>

  <div className="container position-relative">

    {/* LOGO */}
    <a
      className="navbar-brand d-flex align-items-center"
      href="#home"
    >

      {/* ICON BOX */}
      <div
        className="rounded-circle d-flex align-items-center justify-content-center me-3 shadow"
        style={{
          width: "52px",
          height: "52px",
          background:
            "linear-gradient(135deg, #ffc107 0%, #ffda6a 100%)"
        }}
      >
        <i className="bi bi-heart-fill text-dark fs-4"></i>
      </div>

      {/* TEXT */}
      <div>

        <h5 className="fw-bold mb-0 text-white">
          SANKALP SEWA SANSTHAN
        </h5>

        <small className="text-white-50">
          Sworn To Serve Humanity
        </small>

      </div>

    </a>

    {/* MOBILE BUTTON */}
    <button
      className="navbar-toggler border-0 shadow-none"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    {/* MENU */}
    <div className="collapse navbar-collapse" id="navbarNav">

      <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-2">

        <li className="nav-item">
          <a
            className="nav-link px-3 fw-medium text-white"
            href="#home"
          >
            Home
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link px-3 fw-medium text-white"
            href="#about"
          >
            About Us
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link px-3 fw-medium text-white"
            href="#vision"
          >
            Vision
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link px-3 fw-medium text-white"
            href="#programmes"
          >
            Programmes
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link px-3 fw-medium text-white"
            href="#impact"
          >
            Impact
          </a>
        </li>

        {/* CTA BUTTON */}
        <li className="nav-item mt-3 mt-lg-0">

         <button className="btn btn-warning text-dark fw-bold px-4 py-2 rounded-pill shadow-lg d-flex align-items-center ms-lg-3" onClick={toggleModal}>
                  <i className="bi bi-heart-fill me-2"></i> Donate Now
                </button>

        </li>

      </ul>

    </div>

  </div>
</nav>

      {/* ================= HERO SECTION ================= */}
      <header
        id="home"
        className="hero-section d-flex align-items-center text-white text-center"
        style={{
          minHeight: '100vh',
          background:
            'linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.7)), url("https://images.unsplash.com/photo-1529390079861-591de354faf5?q=80&w=1600&auto=format&fit=crop") center/cover no-repeat'
        }}
      >
        <div className="container">

          <span className="badge bg-warning text-dark px-4 py-2 mb-4 fs-6 shadow">
            Registered Non-Profit Organization Since 2005
          </span>

          <h1 className="display-2 fw-bold mb-4">
            “Sworn To Serve Humanity”
          </h1>

          <p
            className="lead fs-4 mx-auto mb-5"
            style={{ maxWidth: '950px' }}
          >
            Sankalp Sewa Sansthan is dedicated to empowering underprivileged
            children, women, youth, elderly people and specially challenged
            individuals through Education, Health Care, Vocational Training and
            Community Development initiatives.
          </p>

          <div className="d-flex flex-wrap justify-content-center gap-3">
            <a href="#about" className="btn btn-primary btn-lg px-5 py-3 rounded-pill shadow">
              Explore Our Mission
            </a>

            <a href="#contact" className="btn btn-outline-light btn-lg px-5 py-3 rounded-pill">
              Join Our Cause
            </a>
          </div>
        </div>
      </header>

      {/* ================= ABOUT SECTION ================= */}
     <section id="about" className="py-5 bg-light">
  <div className="container py-5">

    <div className="row align-items-center g-5">

      {/* IMAGE SIDE */}
      <div className="col-lg-6">

        <div className="row g-4">

          {/* IMAGE 1 */}
          <div className="col-12">
            <div className="position-relative">

              <img
                src="https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1200&auto=format&fit=crop"
                alt="Sankalp Sewa Sansthan"
                className="img-fluid rounded-4 shadow-lg w-100"
                style={{
                  height: "450px",
                  objectFit: "cover"
                }}
              />

              {/* FLOATING CARD */}
              <div
                className="position-absolute bg-white shadow-lg rounded-4 p-4"
                style={{
                  bottom: "-25px",
                  right: "20px",
                  maxWidth: "230px"
                }}
              >
                <h2 className="fw-bold text-primary mb-1">22+</h2>

                <p className="mb-0 text-muted small">
                  Years of dedicated social service &
                  community development
                </p>
              </div>

            </div>
          </div>

          {/* IMAGE 2 */}
          <div className="col-12 mt-5">

            <div className="position-relative">

              <img
                src="https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?q=80&w=1200&auto=format&fit=crop"
                alt="Helping Children"
                className="img-fluid rounded-4 shadow-lg w-100"
                style={{
                  height: "450px",
                  objectFit: "cover"
                }}
              />

              {/* SMALL OVERLAY CARD */}
              <div
                className="position-absolute bg-primary text-white shadow rounded-4 px-4 py-3"
                style={{
                  top: "20px",
                  left: "20px"
                }}
              >
                <h5 className="fw-bold mb-1">Serving Humanity</h5>

                <p className="small mb-0 text-white-50">
                  Education • Health • Empowerment
                </p>
              </div>

            </div>

          </div>

        </div>

      </div>

      {/* CONTENT SIDE */}
      <div className="col-lg-6">

        <span className="text-primary fw-bold text-uppercase letter-spacing">
          About Sankalp Sewa Sansthan
        </span>

        <h2 className="display-5 fw-bold mt-3 mb-4">
          “Sworn To Serve” Humanity With Compassion & Commitment
        </h2>

        <p className="text-muted fs-5">
          <strong>Sankalp Sewa Sansthan</strong> is a registered non-profit
          organization based in Lucknow, Uttar Pradesh, established on
          <strong> 18 July 2005 </strong>
          by a group of passionate young individuals dedicated to serving society
          without discrimination based on caste, creed, religion, gender or language.
        </p>

        <p className="text-muted">
          Since its inception, the organization has been working tirelessly to
          support children and families struggling with extreme poverty and social
          challenges. Our mission is to bring smiles to the faces of those
          tyrannized by fate by extending both financial and non-financial support
          in the sectors of <strong>Education, Health and Community Development.</strong>
        </p>

        <p className="text-muted">
          Today, with the generous support of donors, schools and colleges,
          we serve not only children and women, but also youth, elderly people
          and specially challenged individuals who often face hunger, lack of
          education, poor health conditions and social rejection.
        </p>

        {/* HIGHLIGHT BOX */}
        <div className="bg-white rounded-4 shadow-sm p-4 border-start border-4 border-primary mt-4">

          <h5 className="fw-bold text-primary mb-3">
            Our Core Mission
          </h5>

          <p className="text-muted mb-3">
            We work towards the overall development and empowerment of
            underprivileged communities by creating opportunities for education,
            healthcare, livelihood and dignity.
          </p>

          <p className="mb-0 fst-italic fw-medium">
            “We aim to hand over to the next generation a world better than
            what we inherited from our fathers and forefathers.”
          </p>
        </div>

        {/* FEATURE POINTS */}
        <div className="row mt-4 g-3">

          <div className="col-md-6">
            <div className="d-flex align-items-start">
              <i className="bi bi-check-circle-fill text-success fs-5 me-2"></i>
              <span className="text-muted">
                Free Educational Centers
              </span>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex align-items-start">
              <i className="bi bi-check-circle-fill text-success fs-5 me-2"></i>
              <span className="text-muted">
                Health Camps & Dispensaries
              </span>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex align-items-start">
              <i className="bi bi-check-circle-fill text-success fs-5 me-2"></i>
              <span className="text-muted">
                Vocational Training Programmes
              </span>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex align-items-start">
              <i className="bi bi-check-circle-fill text-success fs-5 me-2"></i>
              <span className="text-muted">
                Scholarships & Awareness Drives
              </span>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</section>

      {/* ================= STATS SECTION ================= */}
     <section
  className="py-5 position-relative overflow-hidden"
  style={{
    background: "linear-gradient(135deg, #0d6efd 0%, #084298 100%)"
  }}
>
  {/* BACKGROUND SHAPES */}
  <div
    className="position-absolute top-0 start-0 w-100 h-100"
    style={{
      background:
        "radial-gradient(circle at top left, rgba(255,255,255,0.08), transparent 30%), radial-gradient(circle at bottom right, rgba(255,255,255,0.06), transparent 30%)"
    }}
  ></div>

  <div className="container position-relative">

    {/* SECTION TITLE */}
    <div className="text-center text-white mb-5">
      <span className="badge bg-warning text-dark px-4 py-2 mb-3 fw-semibold">
        Our Journey of Impact
      </span>

      <h2 className="display-5 fw-bold">
        Serving Humanity Since 2005
      </h2>

      <p
        className="mx-auto text-white-50 mt-3"
        style={{ maxWidth: "800px" }}
      >
        Through education, healthcare, awareness programmes and community
        development initiatives, Sankalp Sewa Sansthan continues to transform
        lives and spread hope among underprivileged communities.
      </p>
    </div>

    {/* STATS CARDS */}
    <div className="row g-4 text-center">

      {/* YEARS */}
      <div className="col-md-6 col-lg-3">
        <div className="bg-white bg-opacity-10 backdrop-blur rounded-4 p-4 h-100 shadow-lg border border-light border-opacity-10">

          <div className="mb-3">
            <i className="bi bi-calendar-heart fs-1 text-warning"></i>
          </div>

          <h2 className="fw-bold display-4 mb-2 text-white">
            22+
          </h2>

          <p className="mb-0 text-white-50">
            Years of Dedicated Social Service
          </p>

        </div>
      </div>

      {/* PEOPLE */}
      <div className="col-md-6 col-lg-3">
        <div className="bg-white bg-opacity-10 backdrop-blur rounded-4 p-4 h-100 shadow-lg border border-light border-opacity-10">

          <div className="mb-3">
            <i className="bi bi-people-fill fs-1 text-warning"></i>
          </div>

          <h2 className="fw-bold display-4 mb-2 text-white">
            1000+
          </h2>

          <p className="mb-0 text-white-50">
            Children & Families Supported
          </p>

        </div>
      </div>

      {/* CAMPAIGNS */}
      <div className="col-md-6 col-lg-3">
        <div className="bg-white bg-opacity-10 backdrop-blur rounded-4 p-4 h-100 shadow-lg border border-light border-opacity-10">

          <div className="mb-3">
            <i className="bi bi-megaphone-fill fs-1 text-warning"></i>
          </div>

          <h2 className="fw-bold display-4 mb-2 text-white">
            50+
          </h2>

          <p className="mb-0 text-white-50">
            Awareness & Health Campaigns
          </p>

        </div>
      </div>

      {/* STATES */}
      <div className="col-md-6 col-lg-3">
        <div className="bg-white bg-opacity-10 backdrop-blur rounded-4 p-4 h-100 shadow-lg border border-light border-opacity-10">

          <div className="mb-3">
            <i className="bi bi-globe-central-south-asia fs-1 text-warning"></i>
          </div>

          <h2 className="fw-bold display-4 mb-2 text-white">
            3
          </h2>

          <p className="mb-0 text-white-50">
            States Reached Across India
          </p>

        </div>
      </div>

    </div>
  </div>
</section>

      {/* ================= VISION SECTION ================= */}
     <section
  id="vision"
  className="py-5 position-relative overflow-hidden"
  style={{
    background: "linear-gradient(to bottom, #f8fbff, #ffffff)"
  }}
>
  {/* BACKGROUND SHAPE */}
  <div
    className="position-absolute top-0 end-0"
    style={{
      width: "350px",
      height: "350px",
      background: "rgba(13,110,253,0.05)",
      borderRadius: "50%",
      filter: "blur(40px)",
      zIndex: 0
    }}
  ></div>

  <div className="container py-5 position-relative">

    {/* HEADING */}
    <div className="text-center mb-5">

      <span className="badge bg-primary-subtle text-primary px-4 py-2 rounded-pill fw-semibold">
        Vision • Mission • Values
      </span>

      <h2 className="display-4 fw-bold mt-4">
        Creating A World Filled With
        <span className="text-primary"> Hope, Dignity & Humanity</span>
      </h2>

      <p
        className="text-muted mx-auto mt-4 fs-5"
        style={{ maxWidth: "900px" }}
      >
        Sankalp Sewa Sansthan envisions a society where every child enjoys
        childhood, every woman receives dignity and respect, and every human
        being gets equal opportunities to live a healthy, safe and meaningful life.
      </p>

    </div>

    {/* MAIN CARDS */}
    <div className="row g-4">

      {/* SOCIAL JUSTICE */}
      <div className="col-md-6 col-lg-4">
        <div
          className="card border-0 shadow-lg rounded-4 h-100 p-4 position-relative overflow-hidden"
          style={{
            transition: "0.3s"
          }}
        >

          <div
            className="position-absolute top-0 end-0"
            style={{
              width: "120px",
              height: "120px",
              background: "rgba(13,110,253,0.08)",
              borderRadius: "50%",
              transform: "translate(40px,-40px)"
            }}
          ></div>

          <div className="mb-4 position-relative">
            <div
              className="d-inline-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: "80px",
                height: "80px",
                background: "rgba(13,110,253,0.1)"
              }}
            >
              <i className="bi bi-people-fill text-primary fs-1"></i>
            </div>
          </div>

          <h4 className="fw-bold mb-3">
            Social Justice & Equality
          </h4>

          <p className="text-muted">
            We seek a world where girls, women and children live without fear,
            discrimination or social inequality — with dignity, safety and equal rights.
          </p>

          <div className="mt-3">
            <span className="badge bg-light text-dark me-2 mb-2">
              Women Empowerment
            </span>

            <span className="badge bg-light text-dark me-2 mb-2">
              Equal Opportunities
            </span>

            <span className="badge bg-light text-dark mb-2">
              Human Dignity
            </span>
          </div>

        </div>
      </div>

      {/* HEALTHY WORLD */}
      <div className="col-md-6 col-lg-4">
        <div
          className="card border-0 shadow-lg rounded-4 h-100 p-4 position-relative overflow-hidden"
        >

          <div
            className="position-absolute top-0 end-0"
            style={{
              width: "120px",
              height: "120px",
              background: "rgba(220,53,69,0.08)",
              borderRadius: "50%",
              transform: "translate(40px,-40px)"
            }}
          ></div>

          <div className="mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: "80px",
                height: "80px",
                background: "rgba(220,53,69,0.1)"
              }}
            >
              <i className="bi bi-heart-pulse-fill text-danger fs-1"></i>
            </div>
          </div>

          <h4 className="fw-bold mb-3">
            Healthy & Happy Communities
          </h4>

          <p className="text-muted">
            Our mission is to build healthier communities by spreading awareness
            about hygiene, nutrition, family health and disease prevention through
            camps, counselling and healthcare support.
          </p>

          <div className="mt-3">
            <span className="badge bg-light text-dark me-2 mb-2">
              Health Camps
            </span>

            <span className="badge bg-light text-dark me-2 mb-2">
              Awareness Drives
            </span>

            <span className="badge bg-light text-dark mb-2">
              Free Dispensaries
            </span>
          </div>

        </div>
      </div>

      {/* EDUCATION */}
      <div className="col-md-6 col-lg-4">
        <div
          className="card border-0 shadow-lg rounded-4 h-100 p-4 position-relative overflow-hidden"
        >

          <div
            className="position-absolute top-0 end-0"
            style={{
              width: "120px",
              height: "120px",
              background: "rgba(25,135,84,0.08)",
              borderRadius: "50%",
              transform: "translate(40px,-40px)"
            }}
          ></div>

          <div className="mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: "80px",
                height: "80px",
                background: "rgba(25,135,84,0.1)"
              }}
            >
              <i className="bi bi-book-half text-success fs-1"></i>
            </div>
          </div>

          <h4 className="fw-bold mb-3">
            Education & Childhood Protection
          </h4>

          <p className="text-muted">
            We believe education is the foundation of empowerment. Our vision
            is to ensure that no child is deprived of education, love, safety
            and the joy of childhood.
          </p>

          <div className="mt-3">
            <span className="badge bg-light text-dark me-2 mb-2">
              Free Education
            </span>

            <span className="badge bg-light text-dark me-2 mb-2">
              Scholarships
            </span>

            <span className="badge bg-light text-dark mb-2">
              Child Welfare
            </span>
          </div>

        </div>
      </div>

    </div>

    {/* BOTTOM MISSION STATEMENT */}
    <div className="mt-5">

      <div
        className="bg-primary text-white rounded-4 p-5 shadow-lg text-center"
        style={{
          background:
            "linear-gradient(135deg, #0d6efd 0%, #084298 100%)"
        }}
      >

        <div className="mb-4">
          <i className="bi bi-quote fs-1 text-warning"></i>
        </div>

        <h3 className="fw-bold mb-4">
          “Sworn To Serve Humanity”
        </h3>

        <p
          className="fs-5 text-white-50 mx-auto mb-0"
          style={{ maxWidth: "950px" }}
        >
          We aim to create a crime-free, compassionate and empowered society
          where people love and respect each other, no child is abandoned,
          elderly people are cared for with dignity, and communities grow
          together through education, health and humanity.
        </p>

      </div>

    </div>

  </div>
</section>

      {/* ================= PROGRAMMES SECTION ================= */}
      <section
  id="programmes"
  className="py-5 position-relative overflow-hidden"
  style={{
    background: "linear-gradient(to bottom, #f8fbff, #ffffff)"
  }}
>
  {/* BACKGROUND DECORATION */}
  <div
    className="position-absolute top-0 start-0"
    style={{
      width: "300px",
      height: "300px",
      background: "rgba(13,110,253,0.05)",
      borderRadius: "50%",
      filter: "blur(50px)",
      zIndex: 0
    }}
  ></div>

  <div className="container py-5 position-relative">

    {/* SECTION HEADING */}
    <div className="text-center mb-5">

      <span className="badge bg-primary-subtle text-primary px-4 py-2 rounded-pill fw-semibold">
        Our Core Initiatives
      </span>

      <h2 className="display-4 fw-bold mt-4">
        Transforming Lives Through
        <span className="text-primary"> Education, Health & Empowerment</span>
      </h2>

      <p
        className="text-muted fs-5 mx-auto mt-4"
        style={{ maxWidth: "900px" }}
      >
        Sankalp Sewa Sansthan works tirelessly to uplift underprivileged
        communities through impactful programmes focused on education,
        healthcare, women empowerment, skill development and social welfare.
      </p>

    </div>

    {/* PROGRAMME CARDS */}
    <div className="row g-4">

      {/* EDUCATION */}
      <div className="col-md-6 col-lg-3">
        <div
          className="card border-0 shadow-lg rounded-4 h-100 overflow-hidden"
          style={{
            transition: "0.3s ease"
          }}
        >

          {/* TOP BAR */}
          <div
            className="p-3 text-center"
            style={{
              background: "rgba(13,110,253,0.08)"
            }}
          >
            <i className="bi bi-book-fill text-primary fs-1"></i>
          </div>

          <div className="card-body p-4">

            <h4 className="fw-bold mb-3">
              Education Programme
            </h4>

            <p className="text-muted small">
              Education is the foundation of empowerment. We provide free
              education facilities for girls, street children, child labourers
              and school drop-outs across Uttar Pradesh, Uttarakhand and Punjab.
            </p>

            <div className="mt-4">

              <div className="d-flex mb-3">
                <i className="bi bi-check-circle-fill text-primary me-2"></i>
                <span className="small text-muted">
                  Free Educational Centers
                </span>
              </div>

              <div className="d-flex mb-3">
                <i className="bi bi-check-circle-fill text-primary me-2"></i>
                <span className="small text-muted">
                  Scholarships for talented students
                </span>
              </div>

              <div className="d-flex">
                <i className="bi bi-check-circle-fill text-primary me-2"></i>
                <span className="small text-muted">
                  Book Banks & Child Support
                </span>
              </div>

            </div>

          </div>
        </div>
      </div>

      {/* HEALTH */}
      <div className="col-md-6 col-lg-3">
        <div
          className="card border-0 shadow-lg rounded-4 h-100 overflow-hidden"
        >

          <div
            className="p-3 text-center"
            style={{
              background: "rgba(220,53,69,0.08)"
            }}
          >
            <i className="bi bi-heart-pulse-fill text-danger fs-1"></i>
          </div>

          <div className="card-body p-4">

            <h4 className="fw-bold mb-3">
              Health Programme
            </h4>

            <p className="text-muted small">
              We organize health camps, awareness drives and free dispensary
              services to improve community health, hygiene and disease prevention.
            </p>

            <div className="mt-4">

              <div className="d-flex mb-3">
                <i className="bi bi-check-circle-fill text-danger me-2"></i>
                <span className="small text-muted">
                  TB, HIV/AIDS & Diabetes Awareness
                </span>
              </div>

              <div className="d-flex mb-3">
                <i className="bi bi-check-circle-fill text-danger me-2"></i>
                <span className="small text-muted">
                  Women & Family Health Counselling
                </span>
              </div>

              <div className="d-flex">
                <i className="bi bi-check-circle-fill text-danger me-2"></i>
                <span className="small text-muted">
                  Free Medical Camps & Medicines
                </span>
              </div>

            </div>

          </div>
        </div>
      </div>

      {/* VOCATIONAL */}
      <div className="col-md-6 col-lg-3">
        <div
          className="card border-0 shadow-lg rounded-4 h-100 overflow-hidden"
        >

          <div
            className="p-3 text-center"
            style={{
              background: "rgba(255,193,7,0.12)"
            }}
          >
            <i className="bi bi-scissors text-warning fs-1"></i>
          </div>

          <div className="card-body p-4">

            <h4 className="fw-bold mb-3">
              Vocational Training
            </h4>

            <p className="text-muted small">
              We empower poor women and girls with vocational training programmes
              that help them become financially independent and self-confident.
            </p>

            <div className="mt-4">

              <div className="d-flex mb-3">
                <i className="bi bi-check-circle-fill text-warning me-2"></i>
                <span className="small text-muted">
                  Stitching & Embroidery Training
                </span>
              </div>

              <div className="d-flex mb-3">
                <i className="bi bi-check-circle-fill text-warning me-2"></i>
                <span className="small text-muted">
                  Beauty Parlour Skill Development
                </span>
              </div>

              <div className="d-flex">
                <i className="bi bi-check-circle-fill text-warning me-2"></i>
                <span className="small text-muted">
                  Jam & Jelly Making Programmes
                </span>
              </div>

            </div>

          </div>
        </div>
      </div>

      {/* ENVIRONMENT */}
      <div className="col-md-6 col-lg-3">
        <div
          className="card border-0 shadow-lg rounded-4 h-100 overflow-hidden"
        >

          <div
            className="p-3 text-center"
            style={{
              background: "rgba(25,135,84,0.08)"
            }}
          >
            <i className="bi bi-tree-fill text-success fs-1"></i>
          </div>

          <div className="card-body p-4">

            <h4 className="fw-bold mb-3">
              Environment & Welfare
            </h4>

            <p className="text-muted small">
              We organize environmental and welfare initiatives that encourage
              sustainable living, social awareness and humanitarian support.
            </p>

            <div className="mt-4">

              <div className="d-flex mb-3">
                <i className="bi bi-check-circle-fill text-success me-2"></i>
                <span className="small text-muted">
                  Plantation & Green India Drives
                </span>
              </div>

              <div className="d-flex mb-3">
                <i className="bi bi-check-circle-fill text-success me-2"></i>
                <span className="small text-muted">
                  Water Saving & Sanitation Awareness
                </span>
              </div>

              <div className="d-flex">
                <i className="bi bi-check-circle-fill text-success me-2"></i>
                <span className="small text-muted">
                  Winter Shelter & Community Support
                </span>
              </div>

            </div>

          </div>
        </div>
      </div>

    </div>

    {/* BOTTOM CTA */}
    <div className="mt-5">

      <div
        className="rounded-4 p-5 text-center text-white shadow-lg"
        style={{
          background:
            "linear-gradient(135deg, #0d6efd 0%, #084298 100%)"
        }}
      >

        <h3 className="fw-bold mb-3">
          Together, We Can Create Lasting Change
        </h3>

        <p
          className="text-white-50 fs-5 mx-auto mb-4"
          style={{ maxWidth: "850px" }}
        >
          Every initiative we undertake is driven by compassion, dedication and
          the belief that even the smallest effort can transform lives and build
          a brighter future for society.
        </p>

        <a
          href="#contact"
          className="btn btn-warning btn-lg px-5 py-3 rounded-pill fw-semibold shadow"
        >
          Support Our Mission
        </a>

      </div>

    </div>

  </div>
</section>

      {/* ================= IMPACT SECTION ================= */}
     <section
  id="impact"
  className="py-5 position-relative overflow-hidden"
  style={{
    background: "linear-gradient(to bottom, #ffffff, #f8fbff)"
  }}
>
  {/* BACKGROUND SHAPES */}
  <div
    className="position-absolute top-0 start-0"
    style={{
      width: "320px",
      height: "320px",
      background: "rgba(13,110,253,0.06)",
      borderRadius: "50%",
      filter: "blur(70px)"
    }}
  ></div>

  <div
    className="position-absolute bottom-0 end-0"
    style={{
      width: "280px",
      height: "280px",
      background: "rgba(25,135,84,0.06)",
      borderRadius: "50%",
      filter: "blur(60px)"
    }}
  ></div>

  <div className="container py-5 position-relative">

    <div className="row align-items-center g-5">

      {/* LEFT IMAGE SECTION */}
      <div className="col-lg-6">

        <div className="row g-4">

          {/* IMAGE 1 */}
          <div className="col-12">

            <div className="position-relative overflow-hidden rounded-4 shadow-lg">

              <img
                src="https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?q=80&w=1200&auto=format&fit=crop"
                alt="Children Support"
                className="img-fluid w-100"
                style={{
                  height: "550px",
                  objectFit: "cover"
                }}
              />

              {/* OVERLAY */}
              <div
                className="position-absolute bottom-0 start-0 w-100 p-4"
                style={{
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.75), transparent)"
                }}
              >

                <span className="badge bg-primary px-3 py-2 rounded-pill mb-3">
                  Child Welfare
                </span>

                <h3 className="fw-bold text-white">
                  Bringing Hope Through Education
                </h3>

                <p className="text-white-50 mb-0">
                  Supporting children with education, care and opportunities for a better future.
                </p>

              </div>

            </div>

          </div>

          {/* IMAGE 2 */}
          <div className="col-12">

            <div className="position-relative overflow-hidden rounded-4 shadow-lg">

              <img
                src="https://images.unsplash.com/photo-1526256262350-7da7584cf5eb?q=80&w=1200&auto=format&fit=crop"
                alt="Women Empowerment"
                className="img-fluid w-100"
                style={{
                  height: "550px",
                  objectFit: "cover"
                }}
              />

              {/* FLOATING CARD */}
              <div
                className="position-absolute bg-white shadow-lg rounded-4 p-4"
                style={{
                  bottom: "20px",
                  left: "20px",
                  maxWidth: "250px"
                }}
              >

                <div className="d-flex align-items-center">

                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{
                      width: "55px",
                      height: "55px",
                      background: "rgba(255,193,7,0.15)"
                    }}
                  >
                    <i className="bi bi-person-heart text-warning fs-3"></i>
                  </div>

                  <div>
                    <h5 className="fw-bold mb-1">
                      Women Empowerment
                    </h5>

                    <p className="small text-muted mb-0">
                      Building confidence, skills & independence.
                    </p>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* RIGHT CONTENT */}
      <div className="col-lg-6">

        <span className="badge bg-primary-subtle text-primary px-4 py-2 rounded-pill fw-semibold">
          Our Impact & Contribution
        </span>

        <h2 className="display-4 fw-bold mt-4 mb-4">
          Transforming Lives Through
          <span className="text-primary"> Compassion & Action</span>
        </h2>

        <p className="text-muted fs-5">
          Sankalp Sewa Sansthan believes that true change begins with compassion,
          dignity and equal opportunities for all. Through our continuous efforts,
          we support children, women, elderly people and underprivileged families
          struggling with poverty, social rejection and lack of resources.
        </p>

        <p className="text-muted">
          Our programmes are designed not only to provide immediate support but
          also to create long-term social transformation through education,
          healthcare, awareness and livelihood development.
        </p>

        {/* IMPACT POINTS */}
        <div className="mt-5">

          {/* WOMEN */}
          <div className="d-flex align-items-start mb-4">

            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 me-4"
              style={{
                width: "65px",
                height: "65px",
                background: "rgba(255,193,7,0.15)"
              }}
            >
              <i className="bi bi-person-heart text-warning fs-3"></i>
            </div>

            <div>
              <h5 className="fw-bold mb-2">
                Empowering Women & Girls
              </h5>

              <p className="text-muted mb-0">
                We provide vocational training, health awareness and livelihood
                opportunities to help women and girls become financially
                independent and live with dignity.
              </p>
            </div>

          </div>

          {/* CHILDREN */}
          <div className="d-flex align-items-start mb-4">

            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 me-4"
              style={{
                width: "65px",
                height: "65px",
                background: "rgba(13,110,253,0.12)"
              }}
            >
              <i className="bi bi-book-fill text-primary fs-3"></i>
            </div>

            <div>
              <h5 className="fw-bold mb-2">
                Supporting Children & Education
              </h5>

              <p className="text-muted mb-0">
                Through free educational centres, scholarships and book banks,
                we help children access quality education and build a brighter future.
              </p>
            </div>

          </div>

          {/* HUMANITY */}
          <div className="d-flex align-items-start mb-4">

            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 me-4"
              style={{
                width: "65px",
                height: "65px",
                background: "rgba(25,135,84,0.12)"
              }}
            >
              <i className="bi bi-globe2 text-success fs-3"></i>
            </div>

            <div>
              <h5 className="fw-bold mb-2">
                Serving Humanity Beyond Boundaries
              </h5>

              <p className="text-muted mb-0">
                From health camps and free dispensaries to environmental and
                welfare initiatives, we continue to serve communities wherever help is needed.
              </p>
            </div>

          </div>

        </div>

        {/* QUOTE BOX */}
        <div
          className="rounded-4 p-4 mt-5 text-white shadow-lg"
          style={{
            background:
              "linear-gradient(135deg, #0d6efd 0%, #084298 100%)"
          }}
        >

          <div className="d-flex align-items-start">

            <i className="bi bi-quote text-warning fs-1 me-3"></i>

            <div>

              <h5 className="fw-bold mb-2">
                Our Promise
              </h5>

              <p className="mb-0 text-white-50">
                “Our projects spread smiles on the faces that need it the most
                and inspire communities to move towards hope, dignity and self-reliance.”
              </p>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</section>

      {/* ================= CTA SECTION ================= */}
     <section
  className="py-5 position-relative overflow-hidden text-white"
  style={{
    background:
      "linear-gradient(135deg, #0d6efd 0%, #084298 60%, #052c65 100%)"
  }}
>
  {/* BACKGROUND EFFECTS */}
  <div
    className="position-absolute top-0 start-0 w-100 h-100"
    style={{
      background:
        "radial-gradient(circle at top left, rgba(255,255,255,0.08), transparent 30%), radial-gradient(circle at bottom right, rgba(255,255,255,0.06), transparent 30%)"
    }}
  ></div>

  {/* FLOATING SHAPES */}
  <div
    className="position-absolute"
    style={{
      top: "40px",
      left: "60px",
      width: "120px",
      height: "120px",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.05)",
      filter: "blur(5px)"
    }}
  ></div>

  <div
    className="position-absolute"
    style={{
      bottom: "50px",
      right: "80px",
      width: "180px",
      height: "180px",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.05)",
      filter: "blur(10px)"
    }}
  ></div>

  <div className="container py-5 position-relative">

    <div className="row justify-content-center">
      <div className="col-lg-10 text-center">

        {/* ICON */}
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
          style={{
            width: "90px",
            height: "90px",
            background: "rgba(255,255,255,0.12)",
            backdropFilter: "blur(10px)"
          }}
        >
          <i className="bi bi-heart-fill text-warning fs-1"></i>
        </div>

        {/* HEADING */}
        <h2 className="display-3 fw-bold mb-4">
          Together We Can Create
          <span className="text-warning"> A Better Tomorrow</span>
        </h2>

        {/* DESCRIPTION */}
        <p
          className="lead text-white-50 mx-auto mb-5 fs-4"
          style={{ maxWidth: "950px" }}
        >
          Your support helps us provide education to underprivileged children,
          healthcare to vulnerable communities, vocational training to women,
          and hope to families struggling with poverty and social challenges.
        </p>

        {/* CTA BUTTONS */}
        <div className="d-flex flex-wrap justify-content-center gap-3 mb-5">

          <a
            href="#contact"
            className="btn btn-warning btn-lg px-5 py-3 rounded-pill fw-bold shadow"
          >
            <i className="bi bi-heart-fill me-2"></i>
            Support Our Mission
          </a>

          <a
            href="#about"
            className="btn btn-outline-light btn-lg px-5 py-3 rounded-pill fw-semibold"
          >
            Learn More
          </a>

        </div>

        {/* SMALL IMPACT BOXES */}
        <div className="row g-4 justify-content-center mt-2">

          <div className="col-md-4">
            <div
              className="rounded-4 p-4 h-100"
              style={{
                background: "rgba(255,255,255,0.08)",
                backdropFilter: "blur(8px)",
                border: "1px solid rgba(255,255,255,0.1)"
              }}
            >
              <i className="bi bi-book-fill text-warning fs-1 mb-3 d-block"></i>

              <h5 className="fw-bold">
                Educate Children
              </h5>

              <p className="text-white-50 small mb-0">
                Help children access free education, scholarships and a brighter future.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div
              className="rounded-4 p-4 h-100"
              style={{
                background: "rgba(255,255,255,0.08)",
                backdropFilter: "blur(8px)",
                border: "1px solid rgba(255,255,255,0.1)"
              }}
            >
              <i className="bi bi-heart-pulse-fill text-warning fs-1 mb-3 d-block"></i>

              <h5 className="fw-bold">
                Improve Healthcare
              </h5>

              <p className="text-white-50 small mb-0">
                Support medical camps, awareness drives and free healthcare services.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div
              className="rounded-4 p-4 h-100"
              style={{
                background: "rgba(255,255,255,0.08)",
                backdropFilter: "blur(8px)",
                border: "1px solid rgba(255,255,255,0.1)"
              }}
            >
              <i className="bi bi-people-fill text-warning fs-1 mb-3 d-block"></i>

              <h5 className="fw-bold">
                Empower Communities
              </h5>

              <p className="text-white-50 small mb-0">
                Create opportunities for women, youth and families to live with dignity.
              </p>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</section>
      {/* ================= FOOTER ================= */}
      <footer
  id="contact"
  className="position-relative overflow-hidden text-white pt-5"
  style={{
    background:
      "linear-gradient(135deg, #111827 0%, #0f172a 50%, #020617 100%)"
  }}
>
  {/* BACKGROUND GLOW */}
  <div
    className="position-absolute top-0 start-0"
    style={{
      width: "300px",
      height: "300px",
      background: "rgba(13,110,253,0.08)",
      borderRadius: "50%",
      filter: "blur(80px)"
    }}
  ></div>

  <div
    className="position-absolute bottom-0 end-0"
    style={{
      width: "250px",
      height: "250px",
      background: "rgba(255,193,7,0.06)",
      borderRadius: "50%",
      filter: "blur(70px)"
    }}
  ></div>

  <div className="container position-relative">

    {/* TOP FOOTER */}
    <div className="row g-5 pb-5">

      {/* ABOUT */}
      <div className="col-lg-5">

        <div className="d-flex align-items-center mb-4">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{
              width: "60px",
              height: "60px",
              background:
                "linear-gradient(135deg, #0d6efd 0%, #084298 100%)"
            }}
          >
            <i className="bi bi-heart-fill text-warning fs-3"></i>
          </div>

          <div>
            <h3 className="fw-bold mb-0">
              SANKALP SEWA SANSTHAN
            </h3>

            <small className="text-white-50">
              “Sworn To Serve Humanity”
            </small>
          </div>
        </div>

        <p
          className="text-white-50 fs-6"
          style={{ lineHeight: "1.9" }}
        >
          Sankalp Sewa Sansthan is a registered non-profit organization
          dedicated to uplifting underprivileged communities through education,
          healthcare, vocational training, awareness programmes and humanitarian
          support. Since 2005, we have been committed to creating a society filled
          with hope, dignity and equal opportunities for all.
        </p>

        {/* SOCIAL ICONS */}
        <div className="d-flex gap-3 mt-4">

          <a
            href="/"
            className="d-flex align-items-center justify-content-center rounded-circle text-white text-decoration-none"
            style={{
              width: "45px",
              height: "45px",
              background: "rgba(255,255,255,0.08)",
              transition: "0.3s"
            }}
          >
            <i className="bi bi-facebook fs-5"></i>
          </a>

          <a
            href="/"
            className="d-flex align-items-center justify-content-center rounded-circle text-white text-decoration-none"
            style={{
              width: "45px",
              height: "45px",
              background: "rgba(255,255,255,0.08)"
            }}
          >
            <i className="bi bi-instagram fs-5"></i>
          </a>

          <a
            href="/"
            className="d-flex align-items-center justify-content-center rounded-circle text-white text-decoration-none"
            style={{
              width: "45px",
              height: "45px",
              background: "rgba(255,255,255,0.08)"
            }}
          >
            <i className="bi bi-twitter-x fs-5"></i>
          </a>

          <a
            href="/"
            className="d-flex align-items-center justify-content-center rounded-circle text-white text-decoration-none"
            style={{
              width: "45px",
              height: "45px",
              background: "rgba(255,255,255,0.08)"
            }}
          >
            <i className="bi bi-youtube fs-5"></i>
          </a>

        </div>

      </div>

      {/* CONTACT */}
      <div className="col-lg-4">

        <h5 className="fw-bold mb-4 text-warning">
          Contact Information
        </h5>

        {/* ADDRESS */}
        <div className="d-flex align-items-start mb-4">

          <div
            className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
            style={{
              width: "45px",
              height: "45px",
              background: "rgba(13,110,253,0.15)"
            }}
          >
            <i className="bi bi-geo-alt-fill text-primary"></i>
          </div>

          <div>
            <h6 className="fw-semibold mb-1">Office Address</h6>

            <p className="text-white-50 mb-0 small">
              Sector 17/291, Indira Nagar,
              Lucknow, Uttar Pradesh, India
            </p>
          </div>

        </div>

        {/* EMAIL */}
        <div className="d-flex align-items-start mb-4">

          <div
            className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
            style={{
              width: "45px",
              height: "45px",
              background: "rgba(13,110,253,0.15)"
            }}
          >
            <i className="bi bi-envelope-fill text-primary"></i>
          </div>

          <div>
            <h6 className="fw-semibold mb-1">Email Address</h6>

            <p className="text-white-50 mb-0 small">
              info@sankalpsewasansthan.org
            </p>
          </div>

        </div>

        {/* PHONE */}
        <div className="d-flex align-items-start">

          <div
            className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
            style={{
              width: "45px",
              height: "45px",
              background: "rgba(13,110,253,0.15)"
            }}
          >
            <i className="bi bi-telephone-fill text-primary"></i>
          </div>

          <div>
            <h6 className="fw-semibold mb-1">Phone Number</h6>

            <p className="text-white-50 mb-0 small">
              +91 XXXXX XXXXX
            </p>
          </div>

        </div>

      </div>

      {/* QUICK LINKS */}
      <div className="col-lg-3">

        <h5 className="fw-bold mb-4 text-warning">
          Quick Links
        </h5>

        <ul className="list-unstyled footer-links">

          <li className="mb-3">
            <a
              href="#home"
              className="text-white-50 text-decoration-none d-inline-flex align-items-center"
            >
              <i className="bi bi-chevron-right me-2 text-primary"></i>
              Home
            </a>
          </li>

          <li className="mb-3">
            <a
              href="#about"
              className="text-white-50 text-decoration-none d-inline-flex align-items-center"
            >
              <i className="bi bi-chevron-right me-2 text-primary"></i>
              About Us
            </a>
          </li>

          <li className="mb-3">
            <a
              href="#vision"
              className="text-white-50 text-decoration-none d-inline-flex align-items-center"
            >
              <i className="bi bi-chevron-right me-2 text-primary"></i>
              Vision & Mission
            </a>
          </li>

          <li className="mb-3">
            <a
              href="#programmes"
              className="text-white-50 text-decoration-none d-inline-flex align-items-center"
            >
              <i className="bi bi-chevron-right me-2 text-primary"></i>
              Programmes
            </a>
          </li>

          <li>
            <a
              href="#contact"
              className="text-white-50 text-decoration-none d-inline-flex align-items-center"
            >
              <i className="bi bi-chevron-right me-2 text-primary"></i>
              Contact Us
            </a>
          </li>

        </ul>

      </div>

    </div>

    {/* FOOTER BOTTOM */}
    <div
      className="border-top py-4 d-flex flex-column flex-md-row justify-content-between align-items-center"
      style={{
        borderColor: "rgba(255,255,255,0.08)"
      }}
    >

      <p className="text-white-50 small mb-2 mb-md-0">
        © 2026 Sankalp Sewa Sansthan. All Rights Reserved.
      </p>

      <p className="text-white-50 small mb-0">
        Designed with ❤️ for Humanity & Social Change
      </p>

    </div>

  </div>
</footer>
    </div>
  );
}

export default App;